export default class VehicleDetail {
    public regNo?: string;
    public year!: number;
    public make!: string;
    public makeId!: number;
    public model!: string;
    public modelId!: number;
    public modelGroup!: string;
    public modelGroupId!: number;
    public doors!: number;
    public seats!: number;
    public transmission!: string;
    public transmissionId!: number;
    public vehicleModel!: VehicleModelDetail;
    public yearModel!: YearModel;
    public imageURL!: string;

    public get asKey() {
        if (this.regNo) { return this.regNo; }

        return `${this.make}:${this.model}:${this.modelGroup}:${this.year}`;
    }
}

// tslint:disable-next-line:max-classes-per-file
export class VehicleModelDetail {
    public id!: number;
    public name!: string;
    public doors?: number;
}

// tslint:disable-next-line:max-classes-per-file
export class YearModel {
    public generation!: string;
    public startYear!: number;
    public endYear!: number;
    public range!: string;
}
